import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { Button, Card, Typography } from '@chilecompra/react-kit/components'
import Products from './QuoteStepTwo.products'
import { Action, Divider, Grid, WarningIcon } from './QuoteStepTwo.styles'

/**
 * The ProductsContainer's component.
 */
const ProductsContainer = props => {
  const {
    fragmentationAlert,
    productsSaved,
    productsUpdate,
    onRemoveAll,
    onRemoveProduct,
    onUpdateProductsSaved,
    setProductsUpdate,
    unitsMeasureOption
  } = props
  const { authInfo } = useSelector(state => state.authorizationProvider)

  const {
    size: { isDownToTiny }
  } = useViewport()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          color="black1"
          fontSize="18px"
          fontWeight="bold"
          lineHeight="22px"
          margin="16px 0 0"
          variant="body2"
        >
          Productos a cotizar
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        {productsSaved.map(product => (
          <Products
            detail={product.detail}
            key={product.productKey}
            onRemoveProduct={onRemoveProduct}
            productId={product.productId}
            productKey={product.productKey}
            productName={product.productName}
            productsUpdate={productsUpdate}
            quantity={product.quantity}
            setProductsUpdate={setProductsUpdate}
            unit={product.unit}
            unitsMeasureOption={unitsMeasureOption}
          />
        ))}
      </Grid>
      <Grid item xs={12} md>
        {fragmentationAlert && (
          <Grid item xs={12}>
            <Card color="warning">
              <WarningIcon />
              <Typography color="black1" fontSize="14px" lineHeight="18px" variant="body2">
                Ya compraste este tipo de producto en los últimos 30 días, te recomendamos que agrupes tus compras, para
                que puedas conseguir
              </Typography>
              <Typography
                color="black1"
                display="inline"
                fontSize="14px"
                fontWeight="bold"
                lineHeight="18px"
                margin="0 4px 0 0"
                variant="body2"
              >
                mejores condiciones
              </Typography>
              <Typography color="black1" display="inline" fontSize="14px" lineHeight="18px" variant="body2">
                y no incurras en
              </Typography>
              <Typography
                color="black1"
                display="inline"
                fontSize="14px"
                fontWeight="bold"
                lineHeight="18px"
                margin="0 4px"
                variant="body2"
              >
                posibles casos de fragmentación.
              </Typography>
            </Card>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} md={8} container alignItems="center">
        <Grid item sm>
          <Action
            display={isDownToTiny ? 'inline-flex' : 'inline'}
            justifyContent={isDownToTiny ? 'center' : 'flex-start'}
            onClick={onRemoveAll}
            visibility={authInfo.hasObserverRole ? 'hidden' : 'visible'}
          >
            Quitar todos
          </Action>
        </Grid>
        <Grid item sm container justifyContent="flex-end">
          <Button
            color="primary"
            disabled={authInfo.hasObserverRole}
            onClick={onUpdateProductsSaved}
            type="button"
            variant="outlined"
            width={isDownToTiny ? '100%' : '220px'}
          >
            Ingresar productos
          </Button>
        </Grid>
        <Grid container margin="48px 0 32px">
          <Divider />
        </Grid>
      </Grid>
    </Grid>
  )
}

ProductsContainer.defaultProps = {
  fragmentationAlert: false,
  productsSaved: [],
  productsUpdate: {},
  unitsMeasureOption: [],
  onRemoveAll: () => undefined,
  onRemoveProduct: () => undefined,
  onUpdateProductsSaved: () => undefined,
  setProductsUpdate: () => undefined
}

ProductsContainer.propTypes = {
  fragmentationAlert: PropTypes.bool,
  productsSaved: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.number,
      productKey: PropTypes.string,
      productName: PropTypes.string,
      categoryId: PropTypes.number,
      quantity: PropTypes.number,
      unit: PropTypes.number,
      detail: PropTypes.string
    })
  ),
  productsUpdate: PropTypes.objectOf(
    PropTypes.shape({
      productId: PropTypes.number,
      productKey: PropTypes.string,
      productName: PropTypes.string,
      categoryId: PropTypes.number,
      quantity: PropTypes.number,
      unit: PropTypes.number,
      detail: PropTypes.string
    })
  ),
  unitsMeasureOption: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number
    })
  ),
  onRemoveAll: PropTypes.func,
  onRemoveProduct: PropTypes.func,
  onUpdateProductsSaved: PropTypes.func,
  setProductsUpdate: PropTypes.func
}

export default ProductsContainer
